import * as React from "react";
import { Drawer, Box, Divider, IconButton, useTheme } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import MenuContent from "./MenuContent";
import UserMenu from "./UserMenu";

const expandedDrawerWidth = 280;
const collapsedDrawerWidth = 80;

export default function SideMenu() {
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const theme = useTheme();

  const handleDrawerToggle = () => {
    setOpenDrawer((prev) => !prev);
  };

  const forceOpenDrawer = () => {
    setOpenDrawer(true);
  };

  return (
    <Drawer
      variant="permanent"
      open={openDrawer}
      sx={{
        width: openDrawer ? expandedDrawerWidth : collapsedDrawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: openDrawer ? expandedDrawerWidth : collapsedDrawerWidth,
          transition: theme.transitions.create(["width", "background-color"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.standard,
          }),
          overflowX: "hidden",
          backgroundColor: theme.palette.background.paper,
          borderRight: `1px solid ${theme.palette.divider}`,
          boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        },
      }}
    >
      {/* Top collapse button */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: openDrawer ? "flex-end" : "center",
          height: 64,
          px: openDrawer ? 2 : 0,
          borderBottom: `1px solid ${theme.palette.divider}`,
          backgroundColor: (theme) => theme.palette.background.paper,
        }}
      >
        <IconButton 
          onClick={handleDrawerToggle} 
          size="small"
          sx={{
            color: theme.palette.text.secondary,
            width: 32,
            height: 32,
            borderRadius: 1,
            border: `1px solid ${theme.palette.divider}`,
            "&:hover": {
              backgroundColor: theme.palette.background.paper,
              borderColor: theme.palette.primary.main,
              color: theme.palette.primary.main,
            },
            transition: theme.transitions.create(
              ["color", "background-color", "border-color"],
              {
                duration: theme.transitions.duration.shorter,
              }
            ),
          }}
        >
          {openDrawer ? <ChevronLeftIcon /> : <MenuIcon />}
        </IconButton>
      </Box>

      {/* Navigation */}
      <Box 
        sx={{ 
          flexGrow: 1, 
          overflowY: "auto",
          py: 2,
          backgroundColor: theme.palette.background.paper,
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <MenuContent
          drawerOpen={openDrawer}
          onForceOpenDrawer={forceOpenDrawer}
        />
      </Box>

      {/* User section */}
      <Box 
        sx={{ 
          mt: "auto",
          backgroundColor: (theme) => theme.palette.background.paper,
          borderTop: `1px solid ${theme.palette.divider}`,
        }}
      >
        <UserMenu openDrawer={openDrawer} />
      </Box>
    </Drawer>
  );
}
